export default "__VITE_ASSET__QYa_EW37__"